import { Component } from '@angular/core';

@Component({
  templateUrl: './cards.html'  
})
export class CardsComponent { 

    constructor() { }

    get CardCode() {
      return "<pm-card></pm-card>";
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/cards/cards-component.ts